import React from 'react';
import { XCircle, Package, RefreshCw, AlertTriangle, Users, Timer } from 'lucide-react';

const Card = ({ icon, label, value, sub, tone = 'slate' }) => {
  const tones = {
    slate: 'text-slate-300',
    red: 'text-red-400',
    green: 'text-green-400',
    amber: 'text-amber-400',
    blue: 'text-blue-400',
  };
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-4">
      <div className="flex items-center gap-2 text-slate-400 mb-2">
        <span className={tones[tone]}>{icon}</span>
        <span className="text-xs font-medium uppercase tracking-wider">{label}</span>
      </div>
      <div className={`text-2xl font-semibold ${tones[tone]}`}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
};

const SummaryCards = ({ summary }) => {
  if (!summary) return null;

  const topVoider = summary.byVoider?.[0];

  return (
    <div className="flex-shrink-0 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <Card
        icon={<XCircle className="w-4 h-4" />}
        label="Voids"
        value={summary.voidCount.toLocaleString()}
        sub={`across ${summary.ordersWithVoid.toLocaleString()} order${summary.ordersWithVoid === 1 ? '' : 's'}`}
        tone="red"
      />
      <Card
        icon={<RefreshCw className="w-4 h-4" />}
        label="Replacements"
        value={summary.reshipCount.toLocaleString()}
        sub="rows with status S"
        tone="green"
      />
      <Card
        icon={<AlertTriangle className="w-4 h-4" />}
        label="Never reshipped"
        value={summary.ordersNeverReshipped.toLocaleString()}
        sub="voided, no replacement"
        tone="amber"
      />
      <Card
        icon={<Package className="w-4 h-4" />}
        label="Reship rate"
        value={summary.reshipRate === null ? '—' : `${summary.reshipRate}%`}
        sub="of voided orders"
        tone="blue"
      />
      <Card
        icon={<Timer className="w-4 h-4" />}
        label="Median reship"
        value={summary.medianReshipDuration || '—'}
        sub="void to replacement"
      />
      <Card
        icon={<Users className="w-4 h-4" />}
        label="Top voider"
        value={topVoider ? topVoider.name : '—'}
        sub={topVoider
          ? `${topVoider.count} of ${summary.voidCount} · ${summary.distinctVoiders} people total`
          : 'no voids in range'}
      />
    </div>
  );
};

export default SummaryCards;
